<template>
  <div class="mx-8">
    <v-card
      flat
      :color="wc_color"
      class="rounded-lg pb-6"
      style="margin-left: auto; margin-right: auto"
      :width="widthCard"
    >
      <v-card-title v-if="image" class="justify-center px-4">
        <v-img
          v-if="image_size === '100%'"
          :src="image_url"
          width="100"
          height="auto"
        ></v-img>
        <img v-else :src="image_url" :width="TabletSize || mobile_mode ? '100%' : image_size+'%'" />
        <!-- <img v-else :src="image_url" width="100%" /> -->
      </v-card-title>
      <v-card
        v-if="!notintime.swap_end"
        flat
        color="transparent"
        width="100%"
        class="d-flex justify-center align-center my-3"
      >
        <v-card flat :color="wc_bg_title" width="100%" class="mx-4">
          <v-card-title
            :style="`color: ${wc_title}; font-size: 20px;word-break: break-word;`"
            :class="`justify-${wc_justify}`"
          >
            {{ surveyInfo.surveyName }}</v-card-title
          >
          <v-card-subtitle
            :style="`color: ${wc_subtitle};text-align: ${wc_justify};word-break: break-word;`"
            >{{ surveyInfo.surveyDetail }}
          </v-card-subtitle>
        </v-card>
      </v-card>
      <v-card-title
        v-if="range_status === 'end'"
        class="pa-0 d-flex justify-center"
        style="font-size: 16px"
      >
        <v-row no-gutters>
          <v-col cols="12" :class="`d-flex justify-${notintime.text_justify}`">
            <span :style="`color: ${notintime.counting_end_color}`">
              {{ notintime.counting_end_text }}</span
            ></v-col
          >
        </v-row>
        <v-card
          v-if="notintime.swap_end"
          flat
          color="transparent"
          width="100%"
          class="d-flex justify-center align-center my-3"
        >
          <v-card flat :color="wc_bg_title" width="100%" class="mx-4">
            <v-card-title
              :style="`color: ${wc_title}; font-size: 20px;word-break: break-word;`"
              :class="`justify-${wc_justify}`"
            >
              {{ surveyInfo.surveyName }}</v-card-title
            >
            <v-card-subtitle
              :style="`color: ${wc_subtitle};text-align: ${wc_justify};word-break: break-word;`"
              >{{ surveyInfo.surveyDetail }}
            </v-card-subtitle>
          </v-card>
        </v-card>
      </v-card-title>
      <v-card-title
        v-else
        class="pa-0 d-flex justify-center"
        style="font-size: 16px"
      >
        <v-row no-gutters v-if="!notintime.swap_counting">
          <v-col
            cols="12"
            :class="`d-flex justify-${notintime.text_justify}`"
            style="font-size: 16px"
            ><span :style="`color: ${notintime.counting_early_color};`">
              {{ notintime.counting_early_text }}</span
            ></v-col
          >
          <v-col
            cols="12"
            :class="`d-flex justify-${notintime.text_justify}`"
            style="font-size: 16px"
            ><span :style="`color: ${notintime.counting_color};`">
              {{ time }}</span
            ></v-col
          >
        </v-row>
        <v-row no-gutters v-else>
          <v-col
            cols="12"
            :class="`d-flex justify-${notintime.text_justify}`"
            style="font-size: 16px"
            ><span :style="`color: ${notintime.counting_color};`">
              {{ time }}</span
            ></v-col
          >
          <v-col
            cols="12"
            :class="`d-flex justify-${notintime.text_justify}`"
            style="font-size: 16px"
            ><span :style="`color: ${notintime.counting_early_color};`">
              {{ notintime.counting_early_text }}</span
            ></v-col
          >
        </v-row>
      </v-card-title>
    </v-card>
  </div>
</template>
<script>
export default {
  props: [
    "config",
    "surveyInfo",
    "range_status",
    "image",
    "image_url",
    "image_size",
    "wc_color",
    "wc_bg_title",
    "wc_title",
    "wc_subtitle",
    "wc_justify",
    "notintime",
    "wc_fullwidth",
    "mobile_mode",
  ],
  data() {
    return {
      WImg: "100%",
      HImg: "auto",
      time: "0 วัน 0 ชั่วโมง 0 นาที 0 วินาที",
    };
  },
  mounted() {
    if (this.range_status === "early") {
      if (!this.config) {
        this.updateTime();
      }
    }
  },
  computed: {
    TabletSize() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown;
    },
    // widthCard() {
    //   if (this.TabletSize || this.mobile_mode) {
    //     return "100%";
    //   } else {
    //     if (this.image) {
    //       if (this.image_size === "100%") {
    //         return "100%";
    //       } else {
    //         return this.image_size + "%";
    //       }
    //     } else {
    //       return "100%";
    //     }
    //   }
    // },
    widthCard() {
      if (this.TabletSize || this.mobile_mode) {
        return "100%";
      } else {
        return "100%";
      }
    },
  },
  methods: {
    updateTime() {
      // Set the date we're counting down to
      var countDownDate = new Date(
        this.surveyInfo.surveyDatetimeStart
      ).getTime();
      let vm = this;
      // Update the count down every 1 second
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="demo"
        vm.time =
          days +
          " วัน " +
          hours +
          " ชั่วโมง " +
          minutes +
          " นาที " +
          seconds +
          " วินาที ";
        // If the count down is over, write some text
        if (distance < 0) {
          clearInterval(x);
          vm.time = "0 วัน 0 ชั่วโมง 0 นาที 0 วินาที";
          location.reload();
        }
      }, 1000);
    },
  },
};
</script>
